const Footer = ({ onScrollTo }) => {
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] border-t border-[#27272a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <button onClick={() => onScrollTo("#top")} className="flex items-center gap-2 group" data-testid="footer-logo">
              <span className="w-2.5 h-2.5 bg-[#ff4500] group-hover:rotate-45 transition-transform duration-300" />
              <span className="font-display text-2xl font-semibold text-[#f5f5f5]">ErgoAssist</span>
            </button>
            <p className="text-[#a1a1aa] mt-5 max-w-sm leading-relaxed">
              Assistive exoskeletons that prevent musculoskeletal harm before it starts —
              enhancing quality of life and workplace safety.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <h4 className="font-mono-accent text-[11px] uppercase tracking-widest text-[#71717a] mb-5">Explore</h4>
            <ul className="space-y-3">
              {[["Technology", "#technology"], ["Industries", "#industries"], ["Mission", "#mission"], ["About", "#about"]].map(([l, h]) => (
                <li key={h}>
                  <button data-testid={`footer-link-${h.replace("#", "")}`} onClick={() => onScrollTo(h)} className="text-[#a1a1aa] hover:text-[#ff4500] transition-colors duration-200">
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono-accent text-[11px] uppercase tracking-widest text-[#71717a] mb-5">Contact</h4>
            <ul className="space-y-3 text-[#a1a1aa]">
              <li><a href="mailto:hello@ergoassist.com" className="hover:text-[#ff4500] transition-colors duration-200" data-testid="footer-email">hello@ergoassist.com</a></li>
              <li>
                <button onClick={() => onScrollTo("#contact")} className="text-[#ff4500] hover:text-[#e03e00] transition-colors duration-200" data-testid="footer-demo">
                  Request a Demo →
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#27272a] flex flex-col sm:flex-row justify-between gap-4 font-mono-accent text-xs text-[#52525b]">
          <span>© {new Date().getFullYear()} ErgoAssist. All rights reserved.</span>
          <span>Designed & engineered in India.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
